export default "__VITE_ASSET__1d8eb811__"